const COOKIES_CONSENT = 'cookiesConsent'

class CookiesService {

  constructor (Localization, StoreTypes) {
    'ngInject'
    this.requestEdit = false
    this.noConsent = Localization.getLocalizedAppConfig().type !== StoreTypes.STANDALONE
  }

  consentForCookie (cookieName) {
    if (this.noConsent) {
      return false
    }
    let consentValue = this.consent
    if (consentValue) {
      let consentValueForName = consentValue[cookieName]
      if (consentValueForName) {
        return consentValueForName
      }
    }
    return false
  }

  get consent () {
    try {
      if (window.localStorage) {
        if (window.localStorage[COOKIES_CONSENT]) {
          let parsed = JSON.parse(window.localStorage[COOKIES_CONSENT])
          if (typeof parsed === 'boolean') return false // old consent system
          if (parsed.lastUpdate) {
            let today = new Date()
            today.setMonth(today.getMonth() - 6)
            if (Date.parse(parsed.lastUpdate) > today) { // not expired
              return parsed.value
            }
          }
        }
      }
      return false
    } catch (e) {
      return this.cookiesConsent
    }
  }

  set consent (value) {
    try {
      if (window.localStorage) {
        window.localStorage[COOKIES_CONSENT] = JSON.stringify({'value': value, 'lastUpdate': new Date()})
      }
    } catch (e) {
      console.log('the quota is insufficient')
      // on force la fermeture des cookies sans les stocker
      this.cookiesConsent = value
    }
  }
}

export default CookiesService



// WEBPACK FOOTER //
// ./src/app/services/cookies/cookies.service.js